import React from 'react'
import type { StepData } from '../../../services/onboardingService'

interface ScheduleSigningStepProps {
  onComplete?: (stepData: StepData) => Promise<void>
  stepData?: any
  stepKey?: string
}

const ScheduleSigningStep: React.FC<ScheduleSigningStepProps> = ({
  onComplete,
  stepData,
}) => {
  const handleComplete = async () => {
    if (onComplete) {
      await onComplete({
        completedAt: new Date().toISOString(),
        placeholder: true,
      })
    }
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Agendamiento Firma de Contrato
        </h2>
        <p className="text-gray-600">Programación de la firma del contrato</p>
      </div>

      {stepData?.status === 'completed' && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-green-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-green-800 font-medium">
              Cita de firma agendada exitosamente
            </span>
          </div>
        </div>
      )}

      <div className="bg-white p-8 rounded-lg border border-gray-200">
        <div className="text-center">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-pink-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Programación de Firma de Contrato
          </h3>
          <p className="text-gray-600 mb-6">
            ¡Último paso! Agenda una cita para la firma formal del contrato de
            leasing y recibir tu vehículo.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-700">
              <strong>Tiempo estimado:</strong> 5 minutos
            </p>
          </div>

          <div className="bg-amber-50 p-4 rounded-lg mb-6 text-left">
            <h4 className="text-sm font-semibold text-amber-800 mb-2">
              Para la cita de firma necesitarás:
            </h4>
            <ul className="text-sm text-amber-700 space-y-1">
              <li>• Identificación oficial vigente</li>
              <li>• Documentos originales para cotejo</li>
              <li>• Comprobante del pago inicial</li>
              <li>• Representante legal (si aplica)</li>
              <li>• Poder notarial (si aplica)</li>
            </ul>
          </div>

          <div className="bg-green-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-green-700">
              🎉 <strong>¡Felicidades!</strong> Al completar este paso habrás
              terminado todo el proceso de onboarding y estarás listo para
              recibir tu vehículo.
            </p>
          </div>

          <button
            onClick={handleComplete}
            disabled={stepData?.status === 'completed'}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {stepData?.status === 'completed'
              ? 'Completado'
              : 'Simular Completar'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ScheduleSigningStep
